import PropTypes from 'prop-types';
import renderFragment from './render-fragment';
import euUserConsumer from './wrappers/eu-user-consumer';
var AllhomesNonEuUser = function AllhomesNonEuUser(props) {
  return props.isEuUser ? null : renderFragment(props.children);
};
AllhomesNonEuUser.propTypes = {
  isEuUser: PropTypes.bool,
  children: PropTypes.node
};
AllhomesNonEuUser.defaultProps = {
  isEuUser: false,
  children: null
};
export default euUserConsumer(AllhomesNonEuUser);
export { AllhomesNonEuUser as BaseAllhomesNonEuUser };